export default __webpack_public_path__ + "static/media/ic24_fct_Facebook.5dd7b426.svg";